import { Injectable } from "@angular/core";
import { jwtDecode as jwtDecodeImport } from "jwt-decode";
import { JwtPayload, JwtDecodeFunction } from "../model/jwt-payload.model";

/**
 * Extension de globalThis para incluir jwtDecode opcional.
 */
declare global {
  interface GlobalThis {
    jwtDecode?: JwtDecodeFunction;
  }
}

@Injectable({
  providedIn: "root",
})
export class CommonService {
  constructor() {}

  /**
   * Obtiene la informacion decodificada del token JWT almacenado en sessionStorage.
   * Prioriza una funcion global `jwtDecode` si esta disponible (util para tests que mockean window.jwtDecode),
   * y en caso contrario utiliza la implementacion importada desde la dependencia `jwt-decode`.
   *
   * @returns El objeto JwtPayload decodificado o `undefined` si no existe token o ocurre algun error.
   */
  getLoginInfo(): JwtPayload | undefined {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        return undefined;
      }

      // Usar la funcion global si existe (para tests), sino usar la importada
      const decodeFn = (globalThis as GlobalThis).jwtDecode ?? jwtDecodeImport;

      if (typeof decodeFn !== "function") {
        console.error("jwtDecode no es una funcion disponible");
        return undefined;
      }

      return decodeFn(token);
    } catch (err) {
      console.error("error al traer la data de login", err);
      return undefined;
    }
  }

  /**
   * Remueve el token (y cualquier dato de sesion) de sessionStorage.
   */
  removeToken(): void {
    sessionStorage.clear();
  }
}
